import CryptoJS from "crypto-js";

export default class Token {
  static key = "gfbb.token";
  static userKey = 'gfbb.user';
  static userCryptoKey = "secretkey123"

  static get() {
    return sessionStorage.getItem(Token.key) || "";
  }

  static set(val) {
    sessionStorage.setItem(Token.key, val);
  }

  static remove() {
    sessionStorage.removeItem(Token.key);
  }

  static getUser() {
    const decryptStr = (str = "") => CryptoJS.AES.decrypt(str, Token.userCryptoKey).toString(CryptoJS.enc.Utf8);
    const {username, password} = JSON.parse(localStorage.getItem(Token.userKey) || "{}");

    return {
      username: decryptStr(username),
      password: decryptStr(password)
    }
  }

  static setUser({account, password}) {
    // 用户名、密码、
    // Encrypt，加密账号密码

    const encryptStr = (str) => CryptoJS.AES.encrypt(str, Token.userCryptoKey).toString();

    localStorage.setItem(Token.userKey, JSON.stringify({
        account: encryptStr(account),
        password: encryptStr(password),
      })
    );
  }

  static removeUser() {
    localStorage.removeItem(Token.userKey);
    // sessionStorage.removeItem(Token.key);
    // window.parent.postMessage("logout","*")
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/token.js